/**
 * Helpers for working with Supabase Realtime channels safely from React.
 */

/**
 * Make a per-mount unique channel topic.
 *
 * Why: Supabase keeps a process-wide registry of channels keyed by topic.
 * If two mounts of the same hook (or two components, or React StrictMode's
 * double-invoke) call `supabase.channel('shared-topic')`, both get the
 * SAME channel instance. Once it's been `.subscribe()`d, calling `.on()`
 * to add another listener throws:
 *
 *   Uncaught Error: cannot add `postgres_changes` callbacks for
 *   realtime:<topic> after `subscribe()`.
 *
 * For Postgres Changes that's gratuitous: every subscribed channel gets
 * the broadcast independently, so each mount can safely have its own
 * channel. Suffixing with a random id sidesteps the registry collision.
 *
 * Do NOT use this for `presence` or `broadcast` — those *do* require all
 * participants to share a single named topic. For those cases, use
 * `supabase.getChannels().find(...)` to reuse an existing channel.
 */
export const uniqueTopic = (base: string): string =>
  `${base}-${Math.random().toString(36).slice(2, 10)}`;
